<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="700px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="tourCalendarForm"
      v-loading="loading"
      :model="tourCalendar"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      style="margin-bottom: 30px;"
      @submit.native.prevent="store"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="driver"
            label="Képviselő"
          >
            <el-select
              v-model="tourCalendar.driver"
              style="width: 100%;"
              filterable
              value-key="id"
              @change="onUserChange"
            >
              <el-option
                v-for="user in users"
                :key="user.id"
                :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                :value="user"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="car"
            label="Gépjármű"
          >
            <el-select
              v-model="tourCalendar.car"
              style="width: 100%;"
              filterable
              value-key="id"
            >
              <el-option
                v-for="car in cars"
                :key="car.id"
                :label="car.plate_number"
                :value="car"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="Kezdés időpontja"
            prop="start_date"
          >
            <el-date-picker
              v-model="tourCalendar.start_date"
              type="datetime"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd. HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="{ firstDayOfWeek: 1 }"
              default-time="8:00:00"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <hr class="dialog-separator">
    <div
      v-loading="shopLoading"
      v-if="(shops && shops.length) || tourCalendar.all_routes.length"
    >
      <div
        v-for="(route, index) in tourCalendar.all_routes"
        :key="`${index}-routeitem`"
      >
        <el-card
          :key="`${index}-routecard`"
          style="margin-bottom: 30px;"
        >
          <div
            slot="header"
            style="font-weight: 600;"
          >
            #{{ index + 1 }} Bolt
            <el-button
              :key="`${index}-routeitem-button`"
              style="float: right; margin-top: -6px;"
              type="danger"
              size="mini"
              icon="el-icon-remove"
              @click="removeRoute(index)"
            >
              Törlés
            </el-button>
          </div>
          <el-form
            :ref="`routeForm${index}`"
            :model="tourCalendar.all_routes[index]"
            :rules="rules"
          >
            <el-form-item
              prop="shop"
            >
              <el-select
                v-model="tourCalendar.all_routes[index].shop"
                filterable
                style="width: 100%;"
                value-key="id"
              >
                <el-option
                  v-for="shop in shopOptions"
                  :key="shop.id"
                  :value="shop"
                  :label="shopLabel(shop)"
                >
                  <strong>{{ shop.name }}</strong>
                  <template v-if="shop.partner_name">
                    ({{ shop.partner_name }})
                  </template>
                  <span
                    style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                  >
                    <el-tag
                      size="mini"
                      type="info"
                    >
                      {{ shop.postal_code }} {{ shop.city }} {{ shop.street }} {{ shop.address }}
                    </el-tag>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <el-button
        v-if="shops && shops.length"
        style="margin-bottom: 20px;"
        type="success"
        icon="el-icon-plus"
        size="small"
        :disabled="loading"
        @click="addRoute"
      >
        Új bolt
      </el-button>
    </div>
    <div v-if="tourCalendar.driver && (!shops || shops.length === 0) && !shopLoading && !loading">
      <el-alert
        title="Ehhez a képviselőhöz nem tartozik üzlet. A Törzsadatok > Üzletek menüpontban tudsz képviselőt hozzárendelni üzlethez."
        type="warning"
        show-icon
        style="word-break: break-word;"
        :closable="false"
      />
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          :loading="buttonLoading"
          @click="store"
        >
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: ['type', 'tourCalendarId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      taskCount: 1,
      shops: [],
      shopLoading: false,
      tourCalendar: {
        all_routes: [],
      },
      rules: {
        driver: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        car: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        shop: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        start_date: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ]
      },
    };
  },
  computed: {
    cars() {
      return this.$store.getters['car/cars'];
    },
    users() {
      return this.$store.getters['user/users'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új túranap';
      } else if (this.type === 'update') {
        return 'Túranap módosítása';
      } else {
        return '';
      }
    },
    // The driver's shops plus the tour day's own shops that are no longer assigned to the driver
    // (e.g. after a representative replacement), so existing routes stay visible and editable.
    shopOptions() {
      const shops = this.shops || [];
      const shopIds = shops.map(shop => shop.id);
      const routeShops = [];
      this.tourCalendar.all_routes.forEach(route => {
        const shop = route.shop;
        if (shop && !shopIds.includes(shop.id)) {
          shopIds.push(shop.id);
          routeShops.push({
            id: shop.id,
            name: shop.name,
            partner_name: shop.partner_name,
            postal_code: shop.postal_code || (shop.address && shop.address.postal_code),
            city: shop.city || (shop.address && shop.address.city),
            address: shop.address && typeof shop.address === 'object' ? shop.address.address : shop.address,
          });
        }
      });
      return [...shops, ...routeShops];
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    const requiredFetches = [];
    if (!this.users.length) {
      requiredFetches.push(this.$store.dispatch('user/fetchAll'));
    }
    if (!this.cars.length) {
      requiredFetches.push(this.$store.dispatch('car/fetchAll'));
    }
    await Promise.all(requiredFetches);
    if (this.tourCalendarId) {
      this.tourCalendar = await this.$store.dispatch('tourCalendar/fetch', this.tourCalendarId);
      this.shops = await axios.get('api/shops/user/' + this.tourCalendar.driver.id);
    }
    this.loading = false;
  },
  methods: {
    shopLabel(shop) {
      const partner = shop.partner_name ? ` (${shop.partner_name})` : '';
      return `${shop.name}${partner} - ${shop.postal_code} ${shop.city}`;
    },
    async onUserChange() {
      this.shopLoading = true;
      this.shops = await axios.get('api/shops/user/' + this.tourCalendar.driver.id);
      this.tourCalendar.all_routes = [];
      this.shopLoading = false;
    },
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/representative-processes/tour-calendars');
        })
        .catch(() => {
        });
    },
    async store() {
      if (!this.tourCalendar.all_routes.length) {
        return this.$messageWrapper.warning('Nincs hozzáadva bolt');
      }
      this.$refs['tourCalendarForm'].validate(async valid => {
        if (valid) {
          if (this.getRouteErrors() === 0) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('tourCalendar/create', this.tourCalendar);
              } else {
                await this.$store.dispatch('tourCalendar/update', this.tourCalendar);
              }
              this.$store.dispatch('tourCalendar/fetchAll');
              this.$router.replace('/representative-processes/tour-calendars');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        }
      });
    },
    removeRoute(index) {
      this.tourCalendar.all_routes.splice(index, 1);
    },
    addRoute() {
      this.tourCalendar.all_routes.push({
        shop: null,
      });
    },
    getRouteErrors() {
      let routeErrors = 0;
      for (let i = 0; i < this.tourCalendar.all_routes.length; i++) {
        let routeForm = 'routeForm' + i;
        this.$refs[routeForm][0].validate(async valid => {
          if (!valid) {
            routeErrors++;
          }
        });
      }
      return routeErrors;
    },
  }
};
</script>
